import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["postal", "region", "regionName", "prefecture", "city", "town", "address", "display"]

  connect() {
    if (this.postalTarget.value.length === 7) {
      this.showFields()
    }
  }
  
  showFields() {
    ['#region-section', '#prefecture-section', '#city-section', '#town-section', '#address-section'].forEach(id => {
      $(id).fadeIn()
    })
  }
  
  hideFields() {
    ['#region-section', '#prefecture-section', '#city-section', '#town-section', '#address-section'].forEach(id => {
      $(id).fadeOut()
    })
  }
  
  search() {
    const postalCode = this.postalTarget.value.replace("-", "")
    if (postalCode.length !== 7) {
      this.hideFields()
      return
    }
  
    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`)
      .then(res => res.json())
      .then(data => {
        if (!data.results) return
  
        const result = data.results[0]
        const prefName = result.address1
  
        this.prefectureTarget.value = prefName
        this.cityTarget.value = result.address2
        this.townTarget.value = result.address3
  
        fetch(`/get_region_name_by_prefecturename/${encodeURIComponent(prefName)}`)
          .then(res => res.json())
          .then(ids => {
            this.regionTarget.value = ids.region_id
            this.regionNameTarget.value = ids.region_name
            document.querySelector('#prefecture_id').value = ids.prefecture_id
            this.showFields()
            this.buildDisplay()
          })
      })
      .catch(err => console.error(err))
  }
  
  buildDisplay() {
    const postal = this.postalTarget?.value || ""
    const prefecture = this.prefectureTarget?.value || ""
    const city = this.cityTarget?.value || ""
    const town = this.townTarget?.value || ""
    const address = this.addressTarget?.value || ""
  
    const formattedPostal = postal.length === 7
      ? "〒 " + postal.replace(/(\d{3})(\d{4})/, "$1-$2")
      : ""
  
    this.displayTarget.value = [formattedPostal, prefecture, city, town, address].filter(Boolean).join(" ")
  }
}